/* eslint-disable react/no-array-index-key */
import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import HeaderNavigation from 'components/HeaderNavigation';
import { FORM_MAX_WIDTH } from 'utils/constants';
import FooterButtons from 'components/FooterButtons';
import FormBody from 'pages/Users/Form/components/FormBody';
import { CREATE_SCHEMA, DEFAULT_VALUES } from 'pages/Users/Form/constants';
import ROUTES from 'app/routes';
import { API, APIRoutes } from 'api';
import transformErrors from 'utils/api';
import FormWrapper from 'components/FormWrapper';

function UserCreate() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const methods = useForm<UserPayload>({
    mode: 'onChange',
    resolver: yupResolver(CREATE_SCHEMA),
    defaultValues: DEFAULT_VALUES,
  });

  const { handleSubmit, setError } = methods;

  const { mutate: createUser, isLoading } = useMutation(
    (data: UserPayload) =>
      API.post(APIRoutes.users.index(), {
        admin: data,
      }),
    {
      mutationKey: 'usersMutation',
      onSuccess: () => {
        toast.success('Użytkownik został pomyślnie utworzony!');
        navigate(ROUTES.users.base);
        queryClient.invalidateQueries('users');
      },
      onError: (error) => {
        const transformedErrors = transformErrors(error as any, null);
        Object.keys(transformedErrors).forEach((field: string) => {
          setError(field as never, {
            type: 'custom',
            message: transformedErrors[field],
          });
        });
        toast.error('Wystąpił problem podczas tworzenia użytkownika');
      },
    },
  );

  const onSubmit = handleSubmit(async (data: UserPayload) => createUser(data));

  return (
    <Box>
      <HeaderNavigation
        baseCrumb={{
          label: 'Użytkownicy',
          to: ROUTES.users.base,
        }}
        crumbs={[{ to: '', label: 'Dodaj użytkownika' }]}
      />
      <FormWrapper {...methods}>
        <Box
          as="form"
          id="user-creator"
          onSubmit={onSubmit}
          pb="120px"
          maxW={FORM_MAX_WIDTH}
        >
          <FormBody isLoading={isLoading} />
        </Box>
      </FormWrapper>
      <FooterButtons
        isLoading={isLoading}
        isCreate
        formId="user-creator"
        onCancel={() => navigate(-2)}
      />
    </Box>
  );
}

export default UserCreate;
